// // // // // import React, { useEffect, useState } from "react";
// // // // // import { useParams } from "react-router-dom";
// // // // // import { QRCodeCanvas } from "qrcode.react";
// // // // // import "./assignedWorkDetail.css";

// // // // // const statusStages = [
// // // // //   "assigned",
// // // // //   "on the way",
// // // // //   "reached",
// // // // //   "work started",
// // // // //   "work completed",
// // // // // ];

// // // // // const RECEIVER_NAME = "ROOT SERVICES INDIA DEMO";
// // // // // const PAYMENT_NOTE =
// // // // //   "ROOT SERVICES INDIA DEMO PAYMENT BUT THE REAL AMOUNT WILL GET TRANSFERRED TO THE ASHOK";

// // // // // const AssignedWorkDetail = () => {
// // // // //   const { id } = useParams();
// // // // //   const [order, setOrder] = useState(null);
// // // // //   const [showPayment, setShowPayment] = useState(false);

// // // // //   useEffect(() => {
// // // // //     fetch(
// // // // //       `https://www.actrofiteinfotech.com/rootservices/dashboard/get_order.php?id=${id}`
// // // // //     )
// // // // //       .then((res) => res.json())
// // // // //       .then((data) => {
// // // // //         if (data.status === "success") setOrder(data.data);
// // // // //       })
// // // // //       .catch((err) => console.error(err));
// // // // //   }, [id]);

// // // // //   const getAllowedStatuses = (currentStatus) => {
// // // // //     const index = statusStages.indexOf(currentStatus);
// // // // //     if (index === -1) return [statusStages[0]];
// // // // //     return [currentStatus, statusStages[index + 1]].filter(Boolean);
// // // // //   };

// // // // //   const updateStatus = (newStatus) => {
// // // // //     if (!order) return;
// // // // //     if (newStatus === "work completed") {
// // // // //       setShowPayment(true);
// // // // //       return;
// // // // //     }

// // // // //     fetch(
// // // // //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// // // // //       {
// // // // //         method: "POST",
// // // // //         headers: { "Content-Type": "application/json" },
// // // // //         body: JSON.stringify({ id: order.id, order_status: newStatus }),
// // // // //       }
// // // // //     )
// // // // //       .then((res) => res.json())
// // // // //       .then((data) => {
// // // // //         if (data.status === "success")
// // // // //           setOrder({ ...order, order_status: newStatus });
// // // // //         else alert("Failed to update status");
// // // // //       })
// // // // //       .catch((err) => console.error(err));
// // // // //   };

// // // // //   const markPaymentDone = () => {
// // // // //     fetch(
// // // // //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// // // // //       {
// // // // //         method: "POST",
// // // // //         headers: { "Content-Type": "application/json" },
// // // // //         body: JSON.stringify({ id: order.id, order_status: "work completed" }),
// // // // //       }
// // // // //     )
// // // // //       .then((res) => res.json())
// // // // //       .then((data) => {
// // // // //         if (data.status === "success") {
// // // // //           setOrder({ ...order, order_status: "work completed" });
// // // // //           setShowPayment(false);
// // // // //           alert("Payment confirmed and work marked as completed!");
// // // // //         } else alert("Failed to confirm payment");
// // // // //       })
// // // // //       .catch((err) => console.error(err));
// // // // //   };

// // // // //   const getUpiLink = (amount) => {
// // // // //     const UPI_ID = "8978975045-3@ybl";
// // // // //     return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
// // // // //       RECEIVER_NAME
// // // // //     )}&tn=${encodeURIComponent(PAYMENT_NOTE)}&am=${amount}&cu=INR`;
// // // // //   };

// // // // //   if (!order) return <p style={{ textAlign: "center" }}>Loading...</p>;

// // // // //   return (
// // // // //     <div className="assigned-detail-container">
// // // // //       <h2>Order Details</h2>
// // // // //       <div className="detail-card">
// // // // //         <p><strong>Order ID:</strong> {order.id}</p>
// // // // //         <p><strong>Customer:</strong> {order.name}</p>
// // // // //         <p><strong>Address:</strong> {order.address || "No address"}</p>
// // // // //         <p><strong>Booked At:</strong> {new Date(order.booked_at).toLocaleString()}</p>
// // // // //         <p><strong>Main Service:</strong> {order.main_service}</p>
// // // // //         <p><strong>Sub Service:</strong> {order.sub_service_title}</p>
// // // // //         {order.custom_title && <p><strong>Custom Title:</strong> {order.custom_title}</p>}
// // // // //         {order.custom_description && <p><strong>Description:</strong> {order.custom_description}</p>}
// // // // //         {order.image_url && <img src={order.image_url} alt="Service" className="detail-image"/>}

// // // // //         <div className="status-dropdown">
// // // // //           <label><strong>Update Status:</strong></label>
// // // // //           <select
// // // // //             value={order.order_status}
// // // // //             onChange={(e) => updateStatus(e.target.value)}
// // // // //             disabled={order.order_status === "work completed"}
// // // // //           >
// // // // //             {getAllowedStatuses(order.order_status).map((status) => (
// // // // //               <option key={status} value={status}>{status}</option>
// // // // //             ))}
// // // // //           </select>
// // // // //         </div>

// // // // //         {/* Link to Google Maps when "on the way" */}
// // // // //         {order.order_status === "on the way" && order.latitude && order.longitude && (
// // // // //           <p style={{ marginTop: "10px" }}>
// // // // //             <strong>Customer Location: </strong>
// // // // //             <a
// // // // //               href={`https://www.google.com/maps?q=${order.latitude},${order.longitude}`}
// // // // //               target="_blank"
// // // // //               rel="noopener noreferrer"
// // // // //             >
// // // // //               View Map
// // // // //             </a>
// // // // //           </p>
// // // // //         )}

// // // // //         {/* Payment Popup */}
// // // // //         {showPayment && (
// // // // //           <div className="payment-popup">
// // // // //             <div className="payment-popup-content">
// // // // //               <h3>Complete Payment</h3>
// // // // //               <QRCodeCanvas
// // // // //                 value={getUpiLink(order.discount_price || order.original_price)}
// // // // //                 size={220}
// // // // //               />
// // // // //               <p>{RECEIVER_NAME}</p>
// // // // //               <p>Amount: ₹{order.discount_price || order.original_price}</p>
// // // // //               <button className="confirm-btn" onClick={markPaymentDone}>
// // // // //                 I Have Paid / Mark as Received
// // // // //               </button>
// // // // //               <button className="cancel-btn" onClick={() => setShowPayment(false)}>
// // // // //                 Cancel
// // // // //               </button>
// // // // //             </div>
// // // // //           </div>
// // // // //         )}
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default AssignedWorkDetail;



// // // // import React, { useEffect, useState } from "react";
// // // // import { useParams } from "react-router-dom";
// // // // import { QRCodeCanvas } from "qrcode.react";
// // // // import "./assignedWorkDetail.css";

// // // // const statusStages = [
// // // //   "assigned",
// // // //   "on the way",
// // // //   "reached",
// // // //   "work started",
// // // //   "work completed",
// // // // ];

// // // // const RECEIVER_NAME = "ROOT SERVICES INDIA DEMO";
// // // // const PAYMENT_NOTE =
// // // //   "ROOT SERVICES INDIA DEMO PAYMENT BUT THE REAL AMOUNT WILL GET TRANSFERRED TO THE ASHOK";

// // // // const AssignedWorkDetail = () => {
// // // //   const { id } = useParams();
// // // //   const [order, setOrder] = useState(null);
// // // //   const [showPayment, setShowPayment] = useState(false);
// // // //   const [showAddServicePopup, setShowAddServicePopup] = useState(false);

// // // //   const [mainServices, setMainServices] = useState([]);
// // // //   const [selectedMainService, setSelectedMainService] = useState("");
// // // //   const [subServices, setSubServices] = useState([]);
// // // //   const [selectedSubService, setSelectedSubService] = useState(null);
// // // //   const [addedServices, setAddedServices] = useState([]);

// // // //   // Fetch order details
// // // //   useEffect(() => {
// // // //     fetch(
// // // //       `https://www.actrofiteinfotech.com/rootservices/dashboard/get_order.php?id=${id}`
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.status === "success") setOrder(data.data);
// // // //       })
// // // //       .catch((err) => console.error(err));
// // // //   }, [id]);

// // // //   const getAllowedStatuses = (currentStatus) => {
// // // //     const index = statusStages.indexOf(currentStatus);
// // // //     if (index === -1) return [statusStages[0]];
// // // //     return [currentStatus, statusStages[index + 1]].filter(Boolean);
// // // //   };

// // // //   const updateStatus = (newStatus) => {
// // // //     if (!order) return;
// // // //     if (newStatus === "work completed") {
// // // //       setShowPayment(true);
// // // //       return;
// // // //     }

// // // //     fetch(
// // // //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// // // //       {
// // // //         method: "POST",
// // // //         headers: { "Content-Type": "application/json" },
// // // //         body: JSON.stringify({ id: order.id, order_status: newStatus }),
// // // //       }
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.status === "success")
// // // //           setOrder({ ...order, order_status: newStatus });
// // // //         else alert("Failed to update status");
// // // //       })
// // // //       .catch((err) => console.error(err));
// // // //   };

// // // //   const markPaymentDone = () => {
// // // //     fetch(
// // // //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// // // //       {
// // // //         method: "POST",
// // // //         headers: { "Content-Type": "application/json" },
// // // //         body: JSON.stringify({ id: order.id, order_status: "work completed" }),
// // // //       }
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.status === "success") {
// // // //           setOrder({ ...order, order_status: "work completed" });
// // // //           setShowPayment(false);
// // // //           alert("Payment confirmed and work marked as completed!");
// // // //         } else alert("Failed to confirm payment");
// // // //       })
// // // //       .catch((err) => console.error(err));
// // // //   };

// // // //   const getUpiLink = (amount) => {
// // // //     const UPI_ID = "8978975045-3@ybl";
// // // //     return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
// // // //       RECEIVER_NAME
// // // //     )}&tn=${encodeURIComponent(PAYMENT_NOTE)}&am=${amount}&cu=INR`;
// // // //   };

// // // //   // Fetch main services for dropdown
// // // //   useEffect(() => {
// // // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php")
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         const uniqueMain = [...new Set(data.map((item) => item.main_service))];
// // // //         setMainServices(uniqueMain);
// // // //       })
// // // //       .catch((err) => console.error(err));
// // // //   }, []);

// // // //   // Fetch sub services based on main service
// // // //   const fetchSubServices = (mainService) => {
// // // //     if (!mainService) return;
// // // //     fetch(
// // // //       `https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php?main_service=${encodeURIComponent(
// // // //         mainService
// // // //       )}`
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => setSubServices(data))
// // // //       .catch((err) => console.error(err));
// // // //   };

// // // //   const handleAddService = () => {
// // // //     if (!selectedSubService) return;
// // // //     setAddedServices([...addedServices, selectedSubService]);
// // // //     // Update total cost in order
// // // //     const newTotal =
// // // //       (order.total_cost || order.original_price) +
// // // //       parseFloat(selectedSubService.discount_price || selectedSubService.price || 0);
// // // //     setOrder({ ...order, total_cost: newTotal });
// // // //     setShowAddServicePopup(false);
// // // //     setSelectedMainService("");
// // // //     setSelectedSubService(null);
// // // //     setSubServices([]);
// // // //   };

// // // //   if (!order) return <p style={{ textAlign: "center" }}>Loading...</p>;

// // // //   return (
// // // //     <div className="assigned-detail-container">
// // // //       <h2>Order Details</h2>
// // // //       <div className="detail-card">
// // // //         <p><strong>Order ID:</strong> {order.id}</p>
// // // //         <p><strong>Customer:</strong> {order.name}</p>
// // // //         <p><strong>Address:</strong> {order.address || "No address"}</p>
// // // //         <p><strong>Booked At:</strong> {new Date(order.booked_at).toLocaleString()}</p>
// // // //         <p><strong>Main Service:</strong> {order.main_service}</p>
// // // //         <p><strong>Sub Service:</strong> {order.sub_service_title}</p>
// // // //         {order.custom_title && <p><strong>Custom Title:</strong> {order.custom_title}</p>}
// // // //         {order.custom_description && <p><strong>Description:</strong> {order.custom_description}</p>}
// // // //         {order.image_url && <img src={order.image_url} alt="Service" className="detail-image"/>}

// // // //         <div className="status-dropdown">
// // // //           <label><strong>Update Status:</strong></label>
// // // //           <select
// // // //             value={order.order_status}
// // // //             onChange={(e) => updateStatus(e.target.value)}
// // // //             disabled={order.order_status === "work completed"}
// // // //           >
// // // //             {getAllowedStatuses(order.order_status).map((status) => (
// // // //               <option key={status} value={status}>{status}</option>
// // // //             ))}
// // // //           </select>
// // // //         </div>

// // // //         {/* Show Add More Services button when work started */}
// // // //         {order.order_status === "work started" && (
// // // //           <button
// // // //             className="add-service-btn"
// // // //             onClick={() => setShowAddServicePopup(true)}
// // // //           >
// // // //             Add More Services
// // // //           </button>
// // // //         )}

// // // //         {/* Added Services List */}
// // // //         {addedServices.length > 0 && (
// // // //           <div style={{ marginTop: "10px" }}>
// // // //             <h4>Added Services:</h4>
// // // //             <ul>
// // // //               {addedServices.map((s, i) => (
// // // //                 <li key={i}>
// // // //                   {s.sub_service_title} - ₹{s.discount_price || s.price} ({s.discount_percent || 0}%)
// // // //                 </li>
// // // //               ))}
// // // //             </ul>
// // // //             <p><strong>Total Cost:</strong> ₹{order.total_cost || order.original_price}</p>
// // // //           </div>
// // // //         )}

// // // //         {/* Add Service Popup */}
// // // //         {showAddServicePopup && (
// // // //           <div className="add-service-popup">
// // // //             <div className="add-service-content">
// // // //               <h3>Add More Service</h3>

// // // //               <label>
// // // //                 Main Service:
// // // //                 <select
// // // //                   value={selectedMainService}
// // // //                   onChange={(e) => {
// // // //                     setSelectedMainService(e.target.value);
// // // //                     fetchSubServices(e.target.value);
// // // //                   }}
// // // //                 >
// // // //                   <option value="">-- Select Main Service --</option>
// // // //                   {mainServices.map((m, i) => (
// // // //                     <option key={i} value={m}>{m}</option>
// // // //                   ))}
// // // //                 </select>
// // // //               </label>

// // // //               {subServices.length > 0 && (
// // // //                 <label>
// // // //                   Sub Service:
// // // //                   <select
// // // //                     value={selectedSubService?.id || ""}
// // // //                     onChange={(e) => {
// // // //                       const sub = subServices.find(s => s.id === e.target.value);
// // // //                       setSelectedSubService(sub);
// // // //                     }}
// // // //                   >
// // // //                     <option value="">-- Select Sub Service --</option>
// // // //                     {subServices.map((s) => (
// // // //                       <option key={s.id} value={s.id}>
// // // //                         {s.sub_service_title} - ₹{s.discount_price || s.price} ({s.discount_percent || 0}%)
// // // //                       </option>
// // // //                     ))}
// // // //                   </select>
// // // //                 </label>
// // // //               )}

// // // //               <div style={{ marginTop: "10px" }}>
// // // //                 <button className="confirm-btn" onClick={handleAddService}>
// // // //                   Add Service
// // // //                 </button>
// // // //                 <button
// // // //                   className="cancel-btn"
// // // //                   onClick={() => setShowAddServicePopup(false)}
// // // //                 >
// // // //                   Cancel
// // // //                 </button>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         )}

// // // //         {/* Payment Popup */}
// // // //         {showPayment && (
// // // //           <div className="payment-popup">
// // // //             <div className="payment-popup-content">
// // // //               <h3>Complete Payment</h3>
// // // //               <QRCodeCanvas
// // // //                 value={getUpiLink(order.discount_price || order.original_price)}
// // // //                 size={220}
// // // //               />
// // // //               <p>{RECEIVER_NAME}</p>
// // // //               <p>Amount: ₹{order.discount_price || order.original_price}</p>
// // // //               <button className="confirm-btn" onClick={markPaymentDone}>
// // // //                 I Have Paid / Mark as Received
// // // //               </button>
// // // //               <button className="cancel-btn" onClick={() => setShowPayment(false)}>
// // // //                 Cancel
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         )}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default AssignedWorkDetail;



// // // import React, { useEffect, useState } from "react";
// // // import { useParams } from "react-router-dom";
// // // import { QRCodeCanvas } from "qrcode.react";
// // // import "./assignedWorkDetail.css";

// // // const statusStages = [
// // //   "assigned",
// // //   "on the way",
// // //   "reached",
// // //   "work started",
// // //   "work completed",
// // // ];

// // // const RECEIVER_NAME = "ROOT SERVICES INDIA DEMO";
// // // const PAYMENT_NOTE =
// // //   "ROOT SERVICES INDIA DEMO PAYMENT BUT THE REAL AMOUNT WILL GET TRANSFERRED TO THE ASHOK";

// // // const AssignedWorkDetail = () => {
// // //   const { id } = useParams();
// // //   const [order, setOrder] = useState(null);
// // //   const [showPayment, setShowPayment] = useState(false);
// // //   const [showAddServicePopup, setShowAddServicePopup] = useState(false);

// // //   const [mainServices, setMainServices] = useState([]);
// // //   const [selectedMainService, setSelectedMainService] = useState("");
// // //   const [subServices, setSubServices] = useState([]);
// // //   const [selectedSubService, setSelectedSubService] = useState(null);
// // //   const [addedServices, setAddedServices] = useState([]);

// // //   // Fetch order details
// // //   useEffect(() => {
// // //     fetch(
// // //       `https://www.actrofiteinfotech.com/rootservices/dashboard/get_order.php?id=${id}`
// // //     )
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         if (data.status === "success") setOrder(data.data);
// // //       })
// // //       .catch((err) => console.error(err));
// // //   }, [id]);

// // //   const getAllowedStatuses = (currentStatus) => {
// // //     const index = statusStages.indexOf(currentStatus);
// // //     if (index === -1) return [statusStages[0]];
// // //     return [currentStatus, statusStages[index + 1]].filter(Boolean);
// // //   };

// // //   const updateStatus = (newStatus) => {
// // //     if (!order) return;
// // //     if (newStatus === "work completed") {
// // //       setShowPayment(true);
// // //       return;
// // //     }

// // //     fetch(
// // //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// // //       {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/json" },
// // //         body: JSON.stringify({ id: order.id, order_status: newStatus }),
// // //       }
// // //     )
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         if (data.status === "success")
// // //           setOrder({ ...order, order_status: newStatus });
// // //         else alert("Failed to update status");
// // //       })
// // //       .catch((err) => console.error(err));
// // //   };

// // //   const markPaymentDone = () => {
// // //     fetch(
// // //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// // //       {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/json" },
// // //         body: JSON.stringify({ id: order.id, order_status: "work completed" }),
// // //       }
// // //     )
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         if (data.status === "success") {
// // //           setOrder({ ...order, order_status: "work completed" });
// // //           setShowPayment(false);
// // //           alert("Payment confirmed and work marked as completed!");
// // //         } else alert("Failed to confirm payment");
// // //       })
// // //       .catch((err) => console.error(err));
// // //   };

// // //   const getUpiLink = (amount) => {
// // //     const UPI_ID = "8978975045-3@ybl";
// // //     return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
// // //       RECEIVER_NAME
// // //     )}&tn=${encodeURIComponent(PAYMENT_NOTE)}&am=${amount}&cu=INR`;
// // //   };

// // //   // Fetch main services for dropdown
// // //   useEffect(() => {
// // //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php")
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         const uniqueMain = [...new Set(data.map((item) => item.main_service))];
// // //         setMainServices(uniqueMain);
// // //       })
// // //       .catch((err) => console.error(err));
// // //   }, []);

// // //   // Fetch sub services based on main service
// // //   const fetchSubServices = (mainService) => {
// // //     if (!mainService) return;
// // //     fetch(
// // //       `https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php?main_service=${encodeURIComponent(
// // //         mainService
// // //       )}`
// // //     )
// // //       .then((res) => res.json())
// // //       .then((data) => setSubServices(data))
// // //       .catch((err) => console.error(err));
// // //   };

// // //   const handleAddService = () => {
// // //     if (!selectedSubService) return;
// // //     setAddedServices([...addedServices, selectedSubService]);

// // //     // Update total cost in order
// // //     const newTotal =
// // //       (order.total_cost || order.original_price || 0) +
// // //       parseFloat(selectedSubService.discount_price || selectedSubService.price || 0);
// // //     setOrder({ ...order, total_cost: newTotal });

// // //     // Reset selections
// // //     setSelectedMainService("");
// // //     setSelectedSubService(null);
// // //     setSubServices([]);
// // //     setShowAddServicePopup(false);
// // //   };

// // //   if (!order) return <p style={{ textAlign: "center" }}>Loading...</p>;

// // //   return (
// // //     <div className="assigned-detail-container">
// // //       <h2>Order Details</h2>
// // //       <div className="detail-card">
// // //         <p><strong>Order ID:</strong> {order.id}</p>
// // //         <p><strong>Customer:</strong> {order.name}</p>
// // //         <p><strong>Address:</strong> {order.address || "No address"}</p>
// // //         <p><strong>Booked At:</strong> {new Date(order.booked_at).toLocaleString()}</p>
// // //         <p><strong>Main Service:</strong> {order.main_service}</p>
// // //         <p><strong>Sub Service:</strong> {order.sub_service_title}</p>
// // //         {order.custom_title && <p><strong>Custom Title:</strong> {order.custom_title}</p>}
// // //         {order.custom_description && <p><strong>Description:</strong> {order.custom_description}</p>}
// // //         {order.image_url && <img src={order.image_url} alt="Service" className="detail-image"/>}

// // //         <div className="status-dropdown">
// // //           <label><strong>Update Status:</strong></label>
// // //           <select
// // //             value={order.order_status}
// // //             onChange={(e) => updateStatus(e.target.value)}
// // //             disabled={order.order_status === "work completed"}
// // //           >
// // //             {getAllowedStatuses(order.order_status).map((status) => (
// // //               <option key={status} value={status}>{status}</option>
// // //             ))}
// // //           </select>
// // //         </div>

// // //         {/* Add More Services button */}
// // //         {order.order_status === "work started" && (
// // //           <button
// // //             className="add-service-btn"
// // //             onClick={() => setShowAddServicePopup(true)}
// // //           >
// // //             Add More Services
// // //           </button>
// // //         )}

// // //         {/* Added Services Table */}
// // //         {addedServices.length > 0 && (
// // //           <div style={{ marginTop: "10px" }}>
// // //             <h4>Added Services:</h4>
// // //             <table border="1" cellPadding="5" style={{ width: "100%", textAlign: "left" }}>
// // //               <thead>
// // //                 <tr>
// // //                   <th>Sub Service</th>
// // //                   <th>Price</th>
// // //                   <th>Discount</th>
// // //                   <th>Final Price</th>
// // //                 </tr>
// // //               </thead>
// // //               <tbody>
// // //                 {addedServices.map((s, i) => (
// // //                   <tr key={i}>
// // //                     <td>{s.sub_service_title}</td>
// // //                     <td>₹{s.price}</td>
// // //                     <td>{s.discount_percent || 0}%</td>
// // //                     <td>₹{s.discount_price || s.price}</td>
// // //                   </tr>
// // //                 ))}
// // //                 <tr>
// // //                   <td colSpan="3"><strong>Total</strong></td>
// // //                   <td><strong>₹{order.total_cost || order.original_price}</strong></td>
// // //                 </tr>
// // //               </tbody>
// // //             </table>
// // //           </div>
// // //         )}

// // //         {/* Add Service Popup */}
// // //         {showAddServicePopup && (
// // //           <div className="add-service-popup">
// // //             <div className="add-service-content">
// // //               <h3>Add More Service</h3>

// // //               <label>
// // //                 Main Service:
// // //                 <select
// // //                   value={selectedMainService}
// // //                   onChange={(e) => {
// // //                     setSelectedMainService(e.target.value);
// // //                     fetchSubServices(e.target.value);
// // //                   }}
// // //                 >
// // //                   <option value="">-- Select Main Service --</option>
// // //                   {mainServices.map((m, i) => (
// // //                     <option key={i} value={m}>{m}</option>
// // //                   ))}
// // //                 </select>
// // //               </label>

// // //               {subServices.length > 0 && (
// // //                 <label>
// // //                   Sub Service:
// // //                   <select
// // //                     value={selectedSubService?.id || ""}
// // //                     onChange={(e) => {
// // //                       const sub = subServices.find(s => String(s.id) === e.target.value);
// // //                       setSelectedSubService(sub);
// // //                     }}
// // //                   >
// // //                     <option value="">-- Select Sub Service --</option>
// // //                     {subServices.map((s) => (
// // //                       <option key={s.id} value={s.id}>
// // //                         {s.sub_service_title} - ₹{s.discount_price || s.price} ({s.discount_percent || 0}%)
// // //                       </option>
// // //                     ))}
// // //                   </select>
// // //                 </label>
// // //               )}

// // //               <div style={{ marginTop: "10px" }}>
// // //                 <button className="confirm-btn" onClick={handleAddService}>
// // //                   Add Service
// // //                 </button>
// // //                 <button
// // //                   className="cancel-btn"
// // //                   onClick={() => setShowAddServicePopup(false)}
// // //                 >
// // //                   Cancel
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         )}

// // //         {/* Payment Popup */}
// // //         {showPayment && (
// // //           <div className="payment-popup">
// // //             <div className="payment-popup-content">
// // //               <h3>Complete Payment</h3>
// // //               <QRCodeCanvas
// // //                 value={getUpiLink(order.total_cost || order.discount_price || order.original_price)}
// // //                 size={220}
// // //               />
// // //               <p>{RECEIVER_NAME}</p>
// // //               <p>Amount: ₹{order.total_cost || order.discount_price || order.original_price}</p>
// // //               <button className="confirm-btn" onClick={markPaymentDone}>
// // //                 I Have Paid / Mark as Received
// // //               </button>
// // //               <button className="cancel-btn" onClick={() => setShowPayment(false)}>
// // //                 Cancel
// // //               </button>
// // //             </div>
// // //           </div>
// // //         )}

// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default AssignedWorkDetail;



// // import React, { useEffect, useState } from "react";
// // import { useParams } from "react-router-dom";
// // import { QRCodeCanvas } from "qrcode.react";
// // import "./assignedWorkDetail.css";

// // const statusStages = [
// //   "assigned",
// //   "on the way",
// //   "reached",
// //   "work started",
// //   "work completed",
// // ];

// // const RECEIVER_NAME = "ROOT SERVICES INDIA DEMO";
// // const PAYMENT_NOTE =
// //   "ROOT SERVICES INDIA DEMO PAYMENT BUT THE REAL AMOUNT WILL GET TRANSFERRED TO THE ASHOK";

// // const AssignedWorkDetail = () => {
// //   const { id } = useParams();
// //   const [order, setOrder] = useState(null);
// //   const [showPayment, setShowPayment] = useState(false);
// //   const [addedServices, setAddedServices] = useState([]);
// //   const [showAddServicePopup, setShowAddServicePopup] = useState(false);
// //   const [allServicesList, setAllServicesList] = useState([]);
// //   const [selectedMainService, setSelectedMainService] = useState("");
// //   const [selectedSubService, setSelectedSubService] = useState(null);

// //   // Fetch order details
// //   useEffect(() => {
// //     fetch(
// //       `https://www.actrofiteinfotech.com/rootservices/dashboard/get_order.php?id=${id}`
// //     )
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data.status === "success") setOrder(data.data);
// //       })
// //       .catch((err) => console.error(err));
// //   }, [id]);

// //   // Fetch all services for Add Service popup
// //   const fetchServices = async (mainService = "") => {
// //     try {
// //       let url = "https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php";
// //       if (mainService) url += `?main_service=${encodeURIComponent(mainService)}`;

// //       const res = await fetch(url);
// //       const data = await res.json();
// //       if (Array.isArray(data)) setAllServicesList(data);
// //       else setAllServicesList([]);
// //     } catch (err) {
// //       console.error(err);
// //       setAllServicesList([]);
// //     }
// //   };

// //   const getAllowedStatuses = (currentStatus) => {
// //     const index = statusStages.indexOf(currentStatus);
// //     if (index === -1) return [statusStages[0]];
// //     return [currentStatus, statusStages[index + 1]].filter(Boolean);
// //   };

// //   const updateStatus = (newStatus) => {
// //     if (!order) return;
// //     if (newStatus === "work completed") {
// //       setShowPayment(true);
// //       return;
// //     }

// //     fetch(
// //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// //       {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ id: order.id, order_status: newStatus }),
// //       }
// //     )
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data.status === "success")
// //           setOrder({ ...order, order_status: newStatus });
// //         else alert("Failed to update status");
// //       })
// //       .catch((err) => console.error(err));
// //   };

// //   const markPaymentDone = () => {
// //     fetch(
// //       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
// //       {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ id: order.id, order_status: "work completed" }),
// //       }
// //     )
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data.status === "success") {
// //           setOrder({ ...order, order_status: "work completed" });
// //           setShowPayment(false);
// //           alert("Payment confirmed and work marked as completed!");
// //         } else alert("Failed to confirm payment");
// //       })
// //       .catch((err) => console.error(err));
// //   };

// //   const getUpiLink = (amount) => {
// //     const UPI_ID = "8978975045-3@ybl";
// //     return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
// //       RECEIVER_NAME
// //     )}&tn=${encodeURIComponent(PAYMENT_NOTE)}&am=${amount}&cu=INR`;
// //   };

// //   const addServiceToList = () => {
// //     if (!selectedSubService) {
// //       alert("Please select a sub service");
// //       return;
// //     }
// //     setAddedServices([...addedServices, selectedSubService]);
// //     setSelectedMainService("");
// //     setSelectedSubService(null);
// //   };

// //   if (!order) return <p style={{ textAlign: "center" }}>Loading...</p>;

// //   // Combine original + added services
// //   const allServices = [
// //     {
// //       sub_service_title: order.sub_service_title,
// //       price: parseFloat(order.original_price) || 0,
// //       discount_price: parseFloat(order.discount_price) || parseFloat(order.original_price) || 0,
// //       discount_percent: order.discount_percent || 0,
// //     },
// //     ...addedServices,
// //   ];

// //   const totalCost = allServices.reduce(
// //     (sum, s) => sum + parseFloat(s.discount_price || s.price || 0),
// //     0
// //   );

// //   return (
// //     <div className="assigned-detail-container">
// //       <h2>Order Details</h2>
// //       <div className="detail-card">
// //         <p><strong>Order ID:</strong> {order.id}</p>
// //         <p><strong>Customer:</strong> {order.name}</p>
// //         <p><strong>Address:</strong> {order.address || "No address"}</p>
// //         <p><strong>Booked At:</strong> {new Date(order.booked_at).toLocaleString()}</p>
// //         <p><strong>Main Service:</strong> {order.main_service}</p>
// //         <p><strong>Sub Service:</strong> {order.sub_service_title}</p>
// //         {order.custom_title && <p><strong>Custom Title:</strong> {order.custom_title}</p>}
// //         {order.custom_description && <p><strong>Description:</strong> {order.custom_description}</p>}
// //         {order.image_url && <img src={order.image_url} alt="Service" className="detail-image"/>}

// //         <div className="status-dropdown">
// //           <label><strong>Update Status:</strong></label>
// //           <select
// //             value={order.order_status}
// //             onChange={(e) => updateStatus(e.target.value)}
// //             disabled={order.order_status === "work completed"}
// //           >
// //             {getAllowedStatuses(order.order_status).map((status) => (
// //               <option key={status} value={status}>{status}</option>
// //             ))}
// //           </select>
// //         </div>

// //         {/* Show Add Services button when work started */}
// //         {order.order_status === "work started" && (
// //           <>
// //             <button
// //               style={{ marginTop: "10px" }}
// //               onClick={() => {
// //                 setShowAddServicePopup(true);
// //                 fetchServices();
// //               }}
// //             >
// //               Add More Services
// //             </button>

// //             {/* Popup */}
// //             {showAddServicePopup && (
// //               <div className="payment-popup">
// //                 <div className="payment-popup-content">
// //                   <h3>Add Service</h3>
// //                   <label>
// //                     Main Service:
// //                     <select
// //                       value={selectedMainService}
// //                       onChange={(e) => {
// //                         setSelectedMainService(e.target.value);
// //                         fetchServices(e.target.value);
// //                         setSelectedSubService(null);
// //                       }}
// //                     >
// //                       <option value="">--Select Main Service--</option>
// //                       <option value="Cleaning">Cleaning</option>
// //                       <option value="Plumbing">Plumbing</option>
// //                       <option value="Electrical">Electrical</option>
// //                       {/* Add more main services dynamically if needed */}
// //                     </select>
// //                   </label>
// //                   <label>
// //                     Sub Service:
// //                     <select
// //                       value={selectedSubService?.id || ""}
// //                       onChange={(e) => {
// //                         const sub = allServicesList.find(
// //                           (s) => s.id === parseInt(e.target.value)
// //                         );
// //                         setSelectedSubService(sub || null);
// //                       }}
// //                     >
// //                       <option value="">--Select Sub Service--</option>
// //                       {allServicesList.map((s) => (
// //                         <option key={s.id} value={s.id}>
// //                           {s.sub_service_title} - ₹{s.discount_price || s.price}
// //                         </option>
// //                       ))}
// //                     </select>
// //                   </label>
// //                   <div style={{ marginTop: "10px" }}>
// //                     <button onClick={addServiceToList}>Add</button>
// //                     <button onClick={() => setShowAddServicePopup(false)}>Close</button>
// //                   </div>
// //                 </div>
// //               </div>
// //             )}
// //           </>
// //         )}

// //         {/* Services Table */}
// //         <div style={{ marginTop: "10px" }}>
// //           <h4>Services:</h4>
// //           <table border="1" cellPadding="5" style={{ width: "100%", textAlign: "left" }}>
// //             <thead>
// //               <tr>
// //                 <th>Sub Service</th>
// //                 <th>Price</th>
// //                 <th>Discount</th>
// //                 <th>Final Price</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {allServices.map((s, i) => (
// //                 <tr key={i}>
// //                   <td>{s.sub_service_title}</td>
// //                   <td>₹{s.price}</td>
// //                   <td>{s.discount_percent || 0}%</td>
// //                   <td>₹{s.discount_price || s.price}</td>
// //                 </tr>
// //               ))}
// //               <tr>
// //                 <td colSpan="3"><strong>Total</strong></td>
// //                 <td><strong>₹{totalCost}</strong></td>
// //               </tr>
// //             </tbody>
// //           </table>
// //         </div>

// //         {/* Payment Popup */}
// //         {showPayment && (
// //           <div className="payment-popup">
// //             <div className="payment-popup-content">
// //               <h3>Complete Payment</h3>
// //               <QRCodeCanvas
// //                 value={getUpiLink(totalCost)}
// //                 size={220}
// //               />
// //               <p>{RECEIVER_NAME}</p>
// //               <p>Amount: ₹{totalCost}</p>
// //               <button className="confirm-btn" onClick={markPaymentDone}>
// //                 I Have Paid / Mark as Received
// //               </button>
// //               <button className="cancel-btn" onClick={() => setShowPayment(false)}>
// //                 Cancel
// //               </button>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default AssignedWorkDetail;


// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { QRCodeCanvas } from "qrcode.react";
// import "./assignedWorkDetail.css";

// const statusStages = [
//   "assigned",
//   "on the way",
//   "reached",
//   "work started",
//   "work completed",
// ];

// const RECEIVER_NAME = "ROOT SERVICES INDIA DEMO";
// const PAYMENT_NOTE =
//   "ROOT SERVICES INDIA DEMO PAYMENT BUT THE REAL AMOUNT WILL GET TRANSFERRED TO THE ASHOK";

// const AssignedWorkDetail = () => {
//   const { id } = useParams();
//   const [order, setOrder] = useState(null);
//   const [showPayment, setShowPayment] = useState(false);

//   // Add service popup states
//   const [showAddServicePopup, setShowAddServicePopup] = useState(false);
//   const [mainServicesList, setMainServicesList] = useState([]);
//   const [selectedMainService, setSelectedMainService] = useState("");
//   const [allServicesList, setAllServicesList] = useState([]);
//   const [selectedSubService, setSelectedSubService] = useState(null);
//   const [addedServices, setAddedServices] = useState([]);

//   // Fetch order
//   useEffect(() => {
//     fetch(
//       `https://www.actrofiteinfotech.com/rootservices/dashboard/get_order.php?id=${id}`
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") setOrder(data.data);
//       })
//       .catch((err) => console.error(err));
//   }, [id]);

//   // Fetch all main services
//   useEffect(() => {
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php")
//       .then((res) => res.json())
//       .then((data) => {
//         if (Array.isArray(data)) {
//           const mainServices = [...new Set(data.map((s) => s.main_service))];
//           setMainServicesList(mainServices);
//         }
//       })
//       .catch((err) => console.error(err));
//   }, []);

//   // Fetch sub-services when main service changes
//   useEffect(() => {
//     if (!selectedMainService) {
//       setAllServicesList([]);
//       setSelectedSubService(null);
//       return;
//     }

//     fetch(
//       `https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php?main_service=${encodeURIComponent(
//         selectedMainService
//       )}`
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (Array.isArray(data)) setAllServicesList(data);
//         else setAllServicesList([]);
//         setSelectedSubService(null);
//       })
//       .catch((err) => console.error(err));
//   }, [selectedMainService]);

//   const getAllowedStatuses = (currentStatus) => {
//     const index = statusStages.indexOf(currentStatus);
//     if (index === -1) return [statusStages[0]];
//     return [currentStatus, statusStages[index + 1]].filter(Boolean);
//   };

//   const updateStatus = (newStatus) => {
//     if (!order) return;
//     if (newStatus === "work completed") {
//       setShowPayment(true);
//       return;
//     }

//     fetch(
//       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: order.id, order_status: newStatus }),
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success")
//           setOrder({ ...order, order_status: newStatus });
//         else alert("Failed to update status");
//       })
//       .catch((err) => console.error(err));
//   };

//   const markPaymentDone = () => {
//     fetch(
//       "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: order.id, order_status: "work completed" }),
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           setOrder({ ...order, order_status: "work completed" });
//           setShowPayment(false);
//           alert("Payment confirmed and work marked as completed!");
//         } else alert("Failed to confirm payment");
//       })
//       .catch((err) => console.error(err));
//   };

//   const getUpiLink = (amount) => {
//     const UPI_ID = "8978975045-3@ybl";
//     return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
//       RECEIVER_NAME
//     )}&tn=${encodeURIComponent(PAYMENT_NOTE)}&am=${amount}&cu=INR`;
//   };

//   const addServiceToList = () => {
//     if (!selectedSubService) return;
//     setAddedServices((prev) => [...prev, selectedSubService]);
//     setSelectedMainService("");
//     setSelectedSubService(null);
//     setAllServicesList([]);
//   };

//   const getTotalAmount = () => {
//     let total = parseFloat(order.discount_price || order.original_price || 0);
//     addedServices.forEach((s) => {
//       total += parseFloat(s.discount_price || s.price || 0);
//     });
//     return total.toFixed(2);
//   };

//   if (!order) return <p style={{ textAlign: "center" }}>Loading...</p>;

//   return (
//     <div className="assigned-detail-container">
//       <h2>Order Details</h2>
//       <div className="detail-card">
//         <p>
//           <strong>Order ID:</strong> {order.id}
//         </p>
//         <p>
//           <strong>Customer:</strong> {order.name}
//         </p>
//         <p>
//           <strong>Address:</strong> {order.address || "No address"}
//         </p>
//         <p>
//           <strong>Booked At:</strong>{" "}
//           {new Date(order.booked_at).toLocaleString()}
//         </p>
//         <p>
//           <strong>Main Service:</strong> {order.main_service}
//         </p>
//         <p>
//           <strong>Sub Service:</strong> {order.sub_service_title}
//         </p>
//         {order.custom_title && (
//           <p>
//             <strong>Custom Title:</strong> {order.custom_title}
//           </p>
//         )}
//         {order.custom_description && (
//           <p>
//             <strong>Description:</strong> {order.custom_description}
//           </p>
//         )}
//         {order.image_url && (
//           <img
//             src={order.image_url}
//             alt="Service"
//             className="detail-image"
//           />
//         )}

//         <div className="status-dropdown">
//           <label>
//             <strong>Update Status:</strong>
//           </label>
//           <select
//             value={order.order_status}
//             onChange={(e) => updateStatus(e.target.value)}
//             disabled={order.order_status === "work completed"}
//           >
//             {getAllowedStatuses(order.order_status).map((status) => (
//               <option key={status} value={status}>
//                 {status}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Button to Add Services */}
//         {order.order_status === "work started" && (
//           <button
//             style={{ marginTop: "10px" }}
//             onClick={() => setShowAddServicePopup(true)}
//           >
//             Add More Services
//           </button>
//         )}

//         {/* Add Service Popup */}
//         {showAddServicePopup && (
//           <div className="payment-popup">
//             <div className="payment-popup-content">
//               <h3>Add Service</h3>
//               <label>
//                 Main Service:
//                 <select
//                   value={selectedMainService}
//                   onChange={(e) => setSelectedMainService(e.target.value)}
//                 >
//                   <option value="">--Select Main Service--</option>
//                   {mainServicesList.map((ms, idx) => (
//                     <option key={idx} value={ms}>
//                       {ms}
//                     </option>
//                   ))}
//                 </select>
//               </label>

//               <label>
//                 Sub Service:
//                 <select
//                   value={selectedSubService?.id || ""}
//                   onChange={(e) => {
//                     const sub = allServicesList.find(
//                       (s) => parseInt(s.id) === parseInt(e.target.value)
//                     );
//                     setSelectedSubService(sub || null);
//                   }}
//                   disabled={!selectedMainService || allServicesList.length === 0}
//                 >
//                   <option value="">--Select Sub Service--</option>
//                   {allServicesList.map((s) => (
//                     <option key={s.id} value={s.id}>
//                       {s.sub_service_title} - ₹{s.discount_price || s.price}
//                     </option>
//                   ))}
//                 </select>
//               </label>

//               <div style={{ marginTop: "10px" }}>
//                 <button onClick={addServiceToList}>Add</button>
//                 <button onClick={() => setShowAddServicePopup(false)}>Close</button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Added Services Table */}
//         {addedServices.length > 0 && (
//           <div style={{ marginTop: "20px" }}>
//             <h4>Added Services</h4>
//             <table style={{ width: "100%", borderCollapse: "collapse" }}>
//               <thead>
//                 <tr>
//                   <th style={{ border: "1px solid #ccc", padding: "5px" }}>
//                     Service
//                   </th>
//                   <th style={{ border: "1px solid #ccc", padding: "5px" }}>
//                     Price
//                   </th>
//                   <th style={{ border: "1px solid #ccc", padding: "5px" }}>
//                     Discount Price
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {addedServices.map((s, idx) => (
//                   <tr key={idx}>
//                     <td style={{ border: "1px solid #ccc", padding: "5px" }}>
//                       {s.sub_service_title}
//                     </td>
//                     <td style={{ border: "1px solid #ccc", padding: "5px" }}>
//                       ₹{s.price}
//                     </td>
//                     <td style={{ border: "1px solid #ccc", padding: "5px" }}>
//                       ₹{s.discount_price || s.price}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <p style={{ marginTop: "10px", fontWeight: "bold" }}>
//               Total Amount: ₹{getTotalAmount()}
//             </p>
//           </div>
//         )}

//         {/* Link to Google Maps */}
//         {order.order_status === "on the way" && order.latitude && order.longitude && (
//           <p style={{ marginTop: "10px" }}>
//             <strong>Customer Location: </strong>
//             <iframe
//               title="Customer Map"
//               width="100%"
//               height="300"
//               style={{ border: 0 }}
//               src={`https://maps.google.com/maps?q=${order.latitude},${order.longitude}&z=15&output=embed`}
//             ></iframe>
//           </p>
//         )}

//         {/* Payment Popup */}
//         {showPayment && (
//           <div className="payment-popup">
//             <div className="payment-popup-content">
//               <h3>Complete Payment</h3>
//               <QRCodeCanvas
//                 value={getUpiLink(getTotalAmount())}
//                 size={220}
//               />
//               <p>{RECEIVER_NAME}</p>
//               <p>Amount: ₹{getTotalAmount()}</p>
//               <button className="confirm-btn" onClick={markPaymentDone}>
//                 I Have Paid / Mark as Received
//               </button>
//               <button className="cancel-btn" onClick={() => setShowPayment(false)}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AssignedWorkDetail;


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import "./assignedWorkDetail.css";

const statusStages = [
  "assigned",
  "on the way",
  "reached",
  "work started",
  "work completed",
];

const RECEIVER_NAME = "ROOT SERVICES INDIA DEMO";
const PAYMENT_NOTE =
  "ROOT SERVICES INDIA DEMO PAYMENT BUT THE REAL AMOUNT WILL GET TRANSFERRED TO THE ASHOK";

const AssignedWorkDetail = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [addedServices, setAddedServices] = useState([]);
  const [servicesData, setServicesData] = useState([]);
  const [mainService, setMainService] = useState("");
  const [subService, setSubService] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Fetch order details
  useEffect(() => {
    fetch(
      `https://www.actrofiteinfotech.com/rootservices/dashboard/get_order.php?id=${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") setOrder(data.data);
      })
      .catch((err) => console.error(err));
  }, [id]);

  // Fetch all services
  useEffect(() => {
    fetch(
      "https://www.actrofiteinfotech.com/rootservices/dashboard/getServices.php"
    )
      .then((res) => res.json())
      .then((data) => setServicesData(data))
      .catch((err) => console.error(err));
  }, []);

  const getAllowedStatuses = (currentStatus) => {
    const index = statusStages.indexOf(currentStatus);
    if (index === -1) return [statusStages[0]];
    return [currentStatus, statusStages[index + 1]].filter(Boolean);
  };

  const updateStatus = (newStatus) => {
    if (!order) return;
    if (newStatus === "work completed") {
      setShowPayment(true);
      return;
    }

    fetch(
      "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: order.id, order_status: newStatus }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success")
          setOrder({ ...order, order_status: newStatus });
        else alert("Failed to update status");
      })
      .catch((err) => console.error(err));
  };

  const markPaymentDone = () => {
    fetch(
      "https://www.actrofiteinfotech.com/rootservices/dashboard/update_status.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: order.id, order_status: "work completed" }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setOrder({ ...order, order_status: "work completed" });
          setShowPayment(false);
          alert("Payment confirmed and work marked as completed!");
        } else alert("Failed to confirm payment");
      })
      .catch((err) => console.error(err));
  };

  const getUpiLink = (amount) => {
    const UPI_ID = "8978975045-3@ybl";
    return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(
      RECEIVER_NAME
    )}&tn=${encodeURIComponent(PAYMENT_NOTE)}&am=${amount}&cu=INR`;
  };

  const handleAddService = () => {
    if (!mainService || !subService) return;
    const selected = servicesData.find(
      (s) => s.main_service === mainService && s.sub_service_title === subService
    );
    if (!selected) return;
    setAddedServices([...addedServices, selected]);
    setMainService("");
    setSubService("");
    setIsPopupOpen(false);
  };

  const getTotalAmount = () => {
    let total = parseFloat(order?.discount_price || order?.original_price || 0);
    addedServices.forEach((s) => {
      total += parseFloat(s.discount_price || s.price || 0);
    });
    return total;
  };
  // Calculate total saved amount
const getTotalSavedAmount = () => {
  let saved = 0;

  // Original order saved amount
  if (order) {
    saved += (order.original_price || 0) - (order.discount_price || order.original_price || 0);
  }

  // Added services saved amount
  addedServices.forEach((s) => {
    saved += (s.price || 0) - (s.discount_price || s.price || 0);
  });

  return saved;
};


  if (!order) return <p style={{ textAlign: "center" }}>Loading...</p>;

  return (
    <div className="assigned-detail-container">
      <h2>Order Details</h2>
      <div className="detail-card">
        <p><strong>Order ID:</strong> {order.id}</p>
        <p><strong>Customer:</strong> {order.name}</p>
        <p><strong>Address:</strong> {order.address || "No address"}</p>
        <p><strong>Booked At:</strong> {new Date(order.booked_at).toLocaleString()}</p>
        <p><strong>Main Service:</strong> {order.main_service}</p>
        <p><strong>Sub Service:</strong> {order.sub_service_title}</p>
        {order.custom_title && <p><strong>Custom Title:</strong> {order.custom_title}</p>}
        {order.custom_description && <p><strong>Description:</strong> {order.custom_description}</p>}
        {order.image_url && <img src={order.image_url} alt="Service" className="detail-image"/>}

        <div className="status-dropdown">
          <label><strong>Update Status:</strong></label>
          <select
            value={order.order_status}
            onChange={(e) => updateStatus(e.target.value)}
            disabled={order.order_status === "work completed"}
          >
            {getAllowedStatuses(order.order_status).map((status) => (
              <option key={status} value={status}>{status}</option>
            ))}
          </select>
        </div>

        {/* Map when on the way */}
        {order.order_status === "on the way" && order.latitude && order.longitude && (
          <div className="map-container" style={{ marginTop: "10px", height: "300px" }}>
            <iframe
              title="Customer Location"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              src={`https://www.google.com/maps?q=${order.latitude},${order.longitude}&output=embed`}
            ></iframe>
          </div>
        )}

        {/* Add More Services when work started */}
        {order.order_status === "work started" && (
          <div style={{ marginTop: "15px" }}>
            <button onClick={() => setIsPopupOpen(true)}>Add More Services</button>
          </div>
        )}

        {/* Add More Services Popup */}
        {isPopupOpen && (
          <div className="popup-overlay">
            <div className="popup-content">
              <h3>Add More Service</h3>
<p className="summary-text">
        Only the <b>service charges are included</b>. Product costs or any gadgets are <strong>not included</strong>.
      </p>

              <label>
                Main Service:
                <select value={mainService} onChange={(e) => setMainService(e.target.value)}>
                  <option value="">-- Select Main Service --</option>
                  {[...new Set(servicesData.map(s => s.main_service))].map((m, i) => (
                    <option key={i} value={m}>{m}</option>
                  ))}
                </select>
              </label>
              <label>
                Sub Service:
                <select value={subService} onChange={(e) => setSubService(e.target.value)}>
  <option value="">-- Select Sub Service --</option>
  {servicesData
    .filter(s => s.main_service === mainService)
    .map((s, i) => (
      <option 
        key={i} 
        value={s.sub_service_title}
      >
        {s.sub_service_title} - ₹{s.discount_price || s.price}
      </option>
    ))}
</select>

              </label>
              <button onClick={handleAddService}>Add</button>
              <button onClick={() => setIsPopupOpen(false)}>Cancel</button>
            </div>
          </div>
        )}

        {/* Services Table */}
       {/* Services Table */}
<div style={{ marginTop: "20px" }}>
  <h4>Services Summary</h4>
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <thead>
      <tr>
        <th style={{ border: "1px solid #ccc", padding: "5px" }}>Service</th>
        <th style={{ border: "1px solid #ccc", padding: "5px" }}>Price</th>
        <th style={{ border: "1px solid #ccc", padding: "5px" }}>Discount %</th>
        <th style={{ border: "1px solid #ccc", padding: "5px" }}>Discount Price</th>
        <th style={{ border: "1px solid #ccc", padding: "5px" }}>Action</th>
      </tr>
    </thead>
    <tbody>
      {/* Original Order */}
      <tr>
        <td style={{ border: "1px solid #ccc", padding: "5px" }}>{order.sub_service_title}</td>
        <td style={{ border: "1px solid #ccc", padding: "5px" }}>₹{order.original_price}</td>
        <td style={{ border: "1px solid #ccc", padding: "5px" }}>
          {order.discount_percent ? `${order.discount_percent}%` : "-"}
        </td>
        <td style={{ border: "1px solid #ccc", padding: "5px" }}>₹{order.discount_price || order.original_price}</td>
        <td style={{ border: "1px solid #ccc", padding: "5px" }}>-</td>
      </tr>

      {/* Added Services */}
      {addedServices.map((s, idx) => (
        <tr key={idx}>
          <td style={{ border: "1px solid #ccc", padding: "5px" }}>{s.sub_service_title}</td>
          <td style={{ border: "1px solid #ccc", padding: "5px" }}>₹{s.price}</td>
          <td style={{ border: "1px solid #ccc", padding: "5px" }}>
            {s.discount_percent ? `${s.discount_percent}%` : "-"}
          </td>
          <td style={{ border: "1px solid #ccc", padding: "5px" }}>₹{s.discount_price || s.price}</td>
          <td style={{ border: "1px solid #ccc", padding: "5px" }}>
            <button onClick={() => {
              setAddedServices(addedServices.filter((_, i) => i !== idx));
            }}>Remove</button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
  <p className="summary-text">Total Amount: ₹{getTotalAmount()}</p>
<p className="summary-text">Saved Amount: ₹{getTotalSavedAmount()}</p>


</div>



        {/* Payment Popup */}
        {showPayment && (
          <div className="payment-popup">
            <div className="payment-popup-content">
              <h3>Complete Payment</h3>
              <QRCodeCanvas
                value={getUpiLink(getTotalAmount())}
                size={220}
              />
              <p>{RECEIVER_NAME}</p>
              <p>Amount: ₹{getTotalAmount()}</p>
              <button className="confirm-btn" onClick={markPaymentDone}>
                I Have Paid / Mark as Received
              </button>
              <button className="cancel-btn" onClick={() => setShowPayment(false)}>
                Cancel
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default AssignedWorkDetail;
